import { TreeSource } from '../../containers/BulkSheetView/lib/tree'
import { TreeRow } from '../../containers/BulkSheetView/model'
import {
  AggregateField,
  AggregateTarget,
} from '../../../domain/entity/WbsItemEntity'
import { GanttParameterVO } from '../../../domain/value-object/GanttParameterVO'
import { CalendarDateVO } from '../../../domain/value-object/CalendarDateVO'
import { WorkLoadUnitState } from '../../hooks/useWorkloadUnit'

export const PROGRAM_MANAGEMENT_ROW_TYPE = {
  PROGRAM: 'PROGRAM',
  GROUP: 'GROUP',
  PROJECT: 'PROJECT',
  WORKGROUP: 'WORKGROUP',
  PROCESS: 'PROCESS',
} as const

export type ProgramManagementRowType =
  (typeof PROGRAM_MANAGEMENT_ROW_TYPE)[keyof typeof PROGRAM_MANAGEMENT_ROW_TYPE]

export type ProgramManagementProgress = {
  total: number
  scheduledCompleted: number
  completed: number
  delayed: number
  preceding: number
}

export type ProgramManagementProgressSet = {
  deliverableCount: ProgramManagementProgress
  deliverableWorkload: ProgramManagementProgress
  taskCount: ProgramManagementProgress
  taskWorkload: ProgramManagementProgress
}

export type ProgramManagementResource = {
  totalResource: number
  investedResource: number
  scheduledResource: number
  actualResource: number
}

export type ProgramManagementProfitLoss = {
  totalBudget: number
  scheduledUsedBudget: number
  actualUsedBudget: number
  remainingBudget: number
  totalRevenue: number
  scheduledRevenue: number
  actualRevenue: number
  forecastRevenue: number
}

export type ProgramManagementResponse =
  TreeSource<ProgramManagementResponse> & {
    uuid: string
    lockVersion: number
    children: ProgramManagementResponse[]
    type: ProgramManagementRowType
    iconUrl?: string
    code?: string
    displayName?: string
    status?: string
    projectManager?: { uuid: string; name: string; iconUrl?: string }
    scheduledDate?: { startDate?: string; endDate?: string }
    progress?: ProgramManagementProgressSet
    resource?: ProgramManagementResource
    profitLoss?: ProgramManagementProfitLoss
  }

export type ProgramManagementRow = TreeRow & {
  type: ProgramManagementRowType
  iconUrl?: string
  lockVersion: number
  code?: string
  displayName?: string
  status?: string
  projectManager?: { uuid: string; name: string; iconUrl?: string }
  scheduledDate?: { startDate?: string; endDate?: string }
  progress?: ProgramManagementProgressSet
  resource?: ProgramManagementResource
  profitLoss?: ProgramManagementProfitLoss
}

export type Program = {
  uuid: string
  code: string
  displayName: string
}

/** ページ状態を valueGetter に渡すための AG Grid context */
export type ProgramManagementGridContext = {
  aggregateTarget: AggregateTarget
  aggregateField: AggregateField
  dateFormat: string
  workloadUnitState?: WorkLoadUnitState
  isRowHeightFixed: boolean
  ganttParameter?: GanttParameterVO
  ganttDisplayTimeScale?: CalendarDateVO[]
  ganttTimeScale?: CalendarDateVO[]
}
